"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractMethod = exports.SwapSide = void 0;
var SwapSide;
(function (SwapSide) {
    SwapSide["BUY"] = "BUY";
    SwapSide["SELL"] = "SELL";
})(SwapSide = exports.SwapSide || (exports.SwapSide = {}));
;
var ContractMethod;
(function (ContractMethod) {
    ContractMethod["swapOnUniswap"] = "swapOnUniswap";
    ContractMethod["buyOnUniswap"] = "buyOnUniswap";
    ContractMethod["swapOnUniswapFork"] = "swapOnUniswapFork";
    ContractMethod["buyOnUniswapFork"] = "buyOnUniswapFork";
    ContractMethod["swapOnUniswapV2Fork"] = "swapOnUniswapV2Fork";
    ContractMethod["buyOnUniswapV2Fork"] = "buyOnUniswapV2Fork";
    ContractMethod["simpleBuy"] = "simpleBuy";
    ContractMethod["simpleSwap"] = "simpleSwap";
    ContractMethod["multiSwap"] = "multiSwap";
    ContractMethod["megaSwap"] = "megaSwap";
    ContractMethod["protectedMultiSwap"] = "protectedMultiSwap";
    ContractMethod["protectedMegaSwap"] = "protectedMegaSwap";
    ContractMethod["protectedSimpleSwap"] = "protectedSimpleSwap";
    ContractMethod["protectedSimpleBuy"] = "protectedSimpleBuy";
    ContractMethod["swapOnZeroXv2"] = "swapOnZeroXv2";
    ContractMethod["swapOnZeroXv4"] = "swapOnZeroXv4";
    ContractMethod["buy"] = "buy"; // TODO: remove this in future
})(ContractMethod = exports.ContractMethod || (exports.ContractMethod = {}));
//# sourceMappingURL=constants.js.map